import type { Transition } from "framer-motion";

/**
 * Named spring presets. Callers pick a *feel* by name instead of re-deriving
 * stiffness/damping numbers, so animations across the app (calendar nesting
 * today; task-creation, overviews, subtasks later) stay consistent and tunable
 * from one place.
 */
export const springs = {
  /** Overshoots and settles — the playful "magic move" used for hover-expand. */
  bouncy: { type: "spring", stiffness: 520, damping: 24, mass: 0.9 },
  /** Soft, no overshoot — for ambient/large layout shifts. */
  gentle: { type: "spring", stiffness: 260, damping: 30, mass: 1 },
  /** Quick and tight — for small, frequent state flips. */
  snappy: { type: "spring", stiffness: 700, damping: 38, mass: 0.6 },
  /** Critically damped — lively but NEVER overshoots/undershoots. Use when an
   *  element must never momentarily render smaller/larger than its target (e.g.
   *  the calendar hover-expand, which must never shrink a block). */
  smooth: { type: "spring", stiffness: 420, damping: 41, mass: 1 },
} satisfies Record<string, Transition>;

export type SpringName = keyof typeof springs;
